import { render } from "./ExpressQuestionsWithoutPricePage.vue?vue&type=template&id=77043e4c"
import script from "./ExpressQuestionsWithoutPricePage.vue?vue&type=script&lang=js"
export * from "./ExpressQuestionsWithoutPricePage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__